import { render, staticRenderFns } from "./TechnicalDocuments.vue?vue&type=template&id=0727da24&"
import script from "./TechnicalDocuments.vue?vue&type=script&lang=js&"
export * from "./TechnicalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports